import React from "react";
import { useNavigate } from "react-router-dom";

import PermissionDenined from "src/components/permissionDenied";
import userRoleService from "src/utils/userRoles.service";

import { RewardsExplorer } from "../components/rewardsExplorer";
import styles from "./rewardsRoute.module.scss";

const MY_SPACE_PATH = "/coaching/courses";

const CoachingRewardsPage: React.FC = () => {
  const navigate = useNavigate();

  if (!userRoleService.canAccessCoaching()) {
    return <PermissionDenined className={styles.permissionDenied} />;
  }

  return (
    <div className={styles.page}>
      <RewardsExplorer onClose={() => navigate(MY_SPACE_PATH)} />
    </div>
  );
};

export { CoachingRewardsPage };
